'use client';

import { useMemo } from 'react';

import { GRS_REFINE_QUERY_PARAM } from '@/components/SearchResultsFacets/constants';
import { SEARCH_SERVICE_PROVIDERS } from '@/constants/grs';
import { useSearchContext } from '@/services/search/SearchProvider';
import { isSearchResultGRS } from '@/services/search/services/Grs';
import { useAdPrismFilters } from '@nxt-costco-com/forge-digital-components';

/** Publishes the completed search request's filters without translating them. */
export default function AdPrismFilterSync(): null {
    const { searchResult, searchedParams, searchService } = useSearchContext();
    const refinement = searchedParams?.[GRS_REFINE_QUERY_PARAM];
    const hasSelections = Array.isArray(refinement)
        ? refinement.some(value => value.trim())
        : !!refinement?.trim();

    const filters = useMemo(() => {
        if (
            searchService !== SEARCH_SERVICE_PROVIDERS.GRS ||
            !hasSelections ||
            !isSearchResultGRS(searchResult) ||
            !searchResult.requestFilters?.length
        ) {
            return undefined;
        }
        return { grs: searchResult.requestFilters };
    }, [searchService, searchResult, hasSelections]);

    useAdPrismFilters(filters);
    return null;
}
